import { Tag, Tooltip } from "antd";
import { Avatar } from "antd";
import { EditTwoTone } from "@ant-design/icons";
import { COLOR_PRIMARY } from "..";
import get from "lodash/get";
import find from 'lodash/find';
import isNaN from "lodash/isNaN";
import { getTimeDifference } from "../../utilities/helpers";

export const tagColor = (role) => {
  switch (role) {
    case "Manager":
      return "gold";
    case "Operator":
      return "purple";
    case "Supervisor":
      return "blue";
    default:
      return "purple";
  }
};
export const staffTypeTag = (role) => {
  switch (role) {
    case "Direct":
      return "geekblue";
    case "Indirect":
      return "cyan";
    case "Other":
      return "green";
    default:
      return "purple";
  }
};
const headerCell = () => ({
  style: { padding: "8px 10px" },
});
const AvatarComponent = ({ name }) => {
  const initials =
    name && typeof name === "string" && get(name, "length") >= 2
      ? name.substring(0, 2).toUpperCase()
      : "--";

  return (
    <div style={{ display: "flex" }}>
      <Avatar
        size={32}
        style={{
          backgroundColor: "#6200EE",
          verticalAlign: "middle",
          borderRadius: "50%",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.3)",
          color: "#FFFFFF",
          fontWeight: "bold",
          fontSize: "1em",
        }}
      >
        {initials}
      </Avatar>
    </div>
  );
};
export const staffColumns = (toggleStaffModal) => [
  {
    title: "Image",
    key: "Image",
    dataIndex: "name",
    onHeaderCell: headerCell,
    render: (text) => {
      return <AvatarComponent name={text} />;
    },
  },
  {
    title: "Full Name",
    key: "full-name",
    dataIndex: "name",
    onHeaderCell: headerCell,
  },
  {
    title: "Role",
    key: "role",
    dataIndex: ["role", "name"],
    onHeaderCell: headerCell,
    render: (text) => {
      return (
        <Tag className="text-center min-w-[100px]" color={tagColor(text)}>
          {text}
        </Tag>
      );
    },
  },
    {
    title: "Staff Manager",
    key: "staff_manager",
    dataIndex: ["manager", "name"],
    onHeaderCell: headerCell,
    render: (text) => {
      return (
        <p>
          {text?text:"--"}
        </p>
      );
    },
  },
   {
    title: "Staff Salary",
    key: 'staff_salary_per_hour_salary',
    dataIndex: ['staff_salary',"per_hour_salary"],
    onHeaderCell: headerCell,
    render:text =>text?text:'--'
  },
     {
    title: "Staff Type",
    key: "staff_type",
    dataIndex: ['staff_type',"name"],
    onHeaderCell: headerCell,
        render: (text) => {
      return (
        <Tag className="text-center min-w-[100px]" color={staffTypeTag(text)}>
          {text}
        </Tag>
      );
    },
  },
       {
    title: "Emp Id",
    key: "emp_id",
    dataIndex: 'emp_id',
    onHeaderCell: headerCell,
        render: (text) => text?text:"--",
  },
  {
    title: "Action",
    key: "id",
    onHeaderCell: headerCell,
    render: (record) => {
      return (
        <Tooltip title="Edit Staff">
          <EditTwoTone
            style={{ fontSize: 20 }}
            twoToneColor={COLOR_PRIMARY}
            onClick={() => {
              toggleStaffModal(record);
            }}
          />
        </Tooltip>
      );
    },
  },
];

export const staffAttendenceColumns = (config) => {
  return [
    {
      title: "Name",
      key: "name",
      dataIndex: "name",
      onHeaderCell: headerCell,
    },
    {
      title: "Role",
      key: "role_name",
      dataIndex: ["role", "name"],
      onHeaderCell: headerCell,
      render: (text) => {
        return (
          <Tag className="text-center min-w-[100px]" color={tagColor(text)}>
            {text}
          </Tag>
        )
      }
    },
           {
    title: "Emp Id",
    key: "emp_id",
    dataIndex: 'emp_id',
    onHeaderCell: headerCell,
        render: (text) => text?text:"--",
  },
     {
      title: "Shift",
      key: "staff_attendance_shift_name",
      dataIndex: ['staff_attendance', "shift",'name'],
      onHeaderCell: headerCell,
      render: text => text || "--"
    },
    {
      title: "In Time",
      key: "staff_attendance_in_time",
      dataIndex: ['staff_attendance', "in_time"],
      onHeaderCell: headerCell,
      render: text => text || "--"
    },
    {
      title: "Out Time",
      key: "staff_attendance_out_time",
      dataIndex: ['staff_attendance', "out_time"],
      onHeaderCell: headerCell,
      render: text => text || "--"
    },
    {
      title: "Working Hours",
      key: "working_hours",
      dataIndex: "working_hours",
      onHeaderCell: headerCell,
      render: (_, record) => {
        const timeDifference = getTimeDifference(get(record, "staff_attendance.in_time", ''), get(record, "staff_attendance.out_time", ''))
        return (
          <p>{!isNaN(timeDifference) ? timeDifference : "--"}</p>
        )
      }
    },
  ]
}